import { HtmlHTMLAttributes } from 'react'
import { Route } from '../../routes'
import BreadcrumbLinks from '../BreadcrumbLinks'
import { LocaleLowerCase } from '../../types/locale'
import { useTranslation } from 'react-i18next'

export function CustomerInfoFormContainer(
  props: HtmlHTMLAttributes<HTMLDivElement>,
) {
  return (
    <div className="page-vertical-spacing">
      <div className={'fds-layout-grid page-container'}>
        <div
          className={'fds-layout-grid__inner grid-gutter-spacing'}
          {...props}
        />
      </div>
    </div>
  )
}

export function GridCell(props: HtmlHTMLAttributes<HTMLDivElement>) {
  return (
    <div
      {...props}
      className={'fds-layout-grid__cell--span-12 ' + props.className}
    />
  )
}

export function CustomerInfoBreadcrumbs({
  locale,
}: {
  locale: LocaleLowerCase
}) {
  const { t } = useTranslation()
  return (
    <GridCell className={'breadcrumbs'}>
      <BreadcrumbLinks
        links={[
          {
            label: t('cart.breadcrumb'),
            url: `/${locale}${Route.YourCart}`,
            active: false,
          },
          {
            label: t('customerInfo.breadcrumb'),
            url: '',
            active: true,
          },
        ]}
      />
    </GridCell>
  )
}

export function ContactInfoColumn(props: HtmlHTMLAttributes<HTMLDivElement>) {
  return (
    <div
      {...props}
      className={
        'fds-layout-grid__cell--span-7-xl ' +
        'fds-layout-grid__cell--span-7-lg ' +
        'fds-layout-grid__cell--span-7-md ' +
        'fds-layout-grid__cell--span-8-sm ' +
        'fds-layout-grid__cell--span-4-xs ' +
        'contact-info-column ' +
        props.className
      }
    />
  )
}

export function ProductInfoColumn(props: HtmlHTMLAttributes<HTMLDivElement>) {
  return (
    <div
      {...props}
      className={
        'fds-layout-grid__cell--span-5-xl ' +
        'fds-layout-grid__cell--span-5-lg ' +
        'fds-layout-grid__cell--span-5-md ' +
        'fds-layout-grid__cell--span-8-sm ' +
        'fds-layout-grid__cell--span-4-xs ' +
        'product-info-column ' +
        props.className
      }
    />
  )
}
